import React from 'react'
import TopBar from '../../Home/Mainhomeone/Topbar'
import Header from '../../Globle/Header1'
import Navigation from '../../Home/Mainhomeone/Navigation'
import Breadcrumb from '../../Globle/Breadecrumb'
import Faq from '../MainFaq/Faq'
import From from '../MainFaq/From'
import Footer1 from '../../Globle/Footer1'

const Main = () => {
    return (
        <>
            <TopBar />
            <Header />
            <Navigation />
            <Breadcrumb title='Faqs' />
            <Faq />
            <From />
            <Footer1 />
        </>
    )
}

export default Main
